import React from 'react';
import { Outlet, Link } from 'react-router-dom';

import MasterAdminHeader from '../components/MasterAdminHeader';
import MasterAdminSidebar from '../components/MasterAdminSidebar';
import DashboardFooter from '../components/DashboardFooter';

interface LayoutProps {
  children?: React.ReactNode;  // Make children optional since we're using Outlet
}

const MasterAdminLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div id="layout-wrapper">
      {/* Header Component */}
      <MasterAdminHeader />
      
      {/* Sidebar Component */}
      <MasterAdminSidebar />

      {/* Main Content Area */}
      <div className="main-content me-0">
        <div className="page-content">
          <div className="container-fluid">
            {/* Page Title Section */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                  {/* <h4 className="mb-sm-0">Super Admin Dashboard</h4> */}

                  {/* Breadcrumb */}
                  {/* <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/superadmin/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Overview</li>
                    </ol>
                  </div> */}
                </div>
              </div>
            </div>

            {/* Render children if passed, otherwise render Outlet */}
            {children ? children : <Outlet />}
          </div>
        </div>

        {/* Footer Component */}
        <DashboardFooter />
      </div>
    </div>
  );
};

export default MasterAdminLayout;
